import { render } from "./SubscriptionsTableLoading.vue?vue&type=template&id=3dadfbe4"
import script from "./SubscriptionsTableLoading.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTableLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__